if (!window.Eurus.loadedScript.includes('hotspot.js')) {
  window.Eurus.loadedScript.push('hotspot.js');
  document.addEventListener('DOMContentLoaded', function () {

    const dots = document.querySelectorAll('button[data-bundle-pin]')
    
    dots.forEach(dot => {
      dot.dataset.clickCount = 0;
      dot.addEventListener('click', function () {
        
        const targetSelector = dot.dataset.trigger;
        const targetspan = document.querySelector('span[data-content="' + targetSelector + '"]')
        targetspan.click();
        dots.forEach(d => {d.classList.remove('active')})  
        dot.classList.toggle('active');

      })
       dot.dataset.clickCount = parseInt(dot.dataset.clickCount) + 1;

      if (parseInt(dot.dataset.clickCount) === 2) {
         dots.forEach(d => {
            d.classList.remove('active');
          });
          const targetDiv = targetspan.parentElement.querySelector('div');
          if (targetDiv) {
            targetDiv.style.height = '0px';
            targetDiv.style.overflow = 'hidden';
            targetDiv.style.display = 'none';
          }
          dot.dataset.clickCount = 0;
        }
    })


    const contents = document.querySelectorAll('span[data-content]')
    contents.forEach(content => {
      content.addEventListener('click', function () {

        const targetContent = content.dataset.content;
        const buttonTarget = document.querySelector('button[data-trigger="' + targetContent + '"]')
        dots.forEach(d => {d.classList.remove('active')})  
        buttonTarget.classList.toggle('active');

      })
    })

const hotspotlist = document.querySelectorAll('.hotspot li');

hotspotlist.forEach(li => {
  li.addEventListener('click', function () {
    hotspotlist.forEach(l => {
      l.classList.remove('active');
      l.classList.add('remove');
    });

    li.classList.add('active');
    li.classList.remove('remove');
  });
});

    
  })
}